import type {
  RewardsAccountResponse,
  Available as AccountRewardsAvailable,
  AccountPrice as PointsBalance,
  FiatPrice,
} from "@b2bportal/hsbc-accounts-api";
import { createSelector } from "@reduxjs/toolkit";
import accountRewardsApi from "./api";

export const isRewardsAccountsAvailable = (
  data?: RewardsAccountResponse
): data is AccountRewardsAvailable =>
  !!data && data.RewardsAccountResponse === "Available";

// Account rewards API selectors
export const accountRewardsResultSelector =
  accountRewardsApi.endpoints.getAccountsRewards.select();

export const accountRewardsSelector = createSelector(
  accountRewardsResultSelector,
  (result) => result?.data
);

export const getPointsBalance = (
  accountRewards?: RewardsAccountResponse
): PointsBalance =>
  isRewardsAccountsAvailable(accountRewards)
    ? accountRewards.pointsBalance
    : undefined;

export const getFiatPointsBalance = (
  accountRewards?: RewardsAccountResponse
): FiatPrice =>
  isRewardsAccountsAvailable(accountRewards)
    ? accountRewards.cashEquivalent
    : undefined;

export const getRewardsAccount = (accountRewards?: RewardsAccountResponse) =>
  isRewardsAccountsAvailable(accountRewards)
    ? accountRewards
    : {
        pointsBalance: undefined,
        cashEquivalent: undefined,
        conversionMultiplier: undefined,
      };

export const getAccountRewardsPoints = createSelector(
  accountRewardsSelector,
  getPointsBalance
);
